/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {Sprite, Container} from 'pixi.js';
import { Store, UpdateManager} from '@gongxigames/framework/core';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {$Container, $Sprite} from '@gongxigames/framework/core/fragments/BuilderY';
import {$FullScreenFader} from '@gongxigames/framework/slotV2/JSX/FullScreenFader';
import {$FullScreenAlign} from '@gongxigames/framework/slotV2/JSX/FullScreenAlign';

type WaitingViewV2Options = {
    updateManager: UpdateManager;
};

export class WaitingViewV2 {
    public static readonly NAME: symbol = Symbol('WaitingView');
    public static layer = LAYERS.SYSTEM_POPUPS;

    public container!: Container;

    protected _updater: UpdateManager = new UpdateManager(true);
    protected _loadingIcon!: Sprite;

    protected showLoadingProcess = Store.signal(false);
    protected width = Store.signal(3920);
    protected height = Store.signal(2160);

    constructor(protected options: WaitingViewV2Options) {
        options.updateManager.add(this._updater);
        this.createMainScene();
    }

    protected createMainScene(): void {
        this._loadingIcon = <$Sprite name='waitingPopup' texture='loader' anchor={0.5}/> as Sprite;

        this.container = <$Container name='popup' visible={this.showLoadingProcess}>
            <$FullScreenFader opacity={0.75} show={true} interactive={true}/>
            <$FullScreenAlign align={0.5}>
                {this._loadingIcon}
            </$FullScreenAlign>
        </$Container> as Container;
    }

    public showPopup(): void {
        this.showLoadingProcess.value = true;
        this.playLoading();
    }

    public hidePopup(): void {
        this.showLoadingProcess.value = false;
        this._updater.removeAll();
    }

    protected playLoading(): void {
        this._updater.addUpdateFunction(delta => {
            this._loadingIcon.rotation += delta * 0.01;
        });
    }
}
